import { render, staticRenderFns } from "./head2.vue?vue&type=template&id=9e3961ec&scoped=true"
import script from "./head2.vue?vue&type=script&lang=js"
export * from "./head2.vue?vue&type=script&lang=js"
import style0 from "./head2.vue?vue&type=style&index=0&id=9e3961ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e3961ec",
  null
  
)

export default component.exports